module.exports = __webpack_public_path__ + "img/logo-dark.1ca926da.svg";